import moment from 'moment';
import { api } from 'shared/api';
import { FileFormat } from 'shared/model/types';
import { downloadFile } from 'shared/libs/helpers/downloadFile';

export const accountApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAccountStatement: build.query<
      Blob,
      {
        accountId: number;
        dateRange: [string, string];
        format?: FileFormat;
        language?: string;
      }
    >({
      query: ({ accountId, dateRange, format = FileFormat.PDF, language = 'EN' }) => {
        const [startRaw, endRaw] = dateRange;
        const startDate = moment(startRaw).format('DD-MM-YYYY');
        const endDate = moment(endRaw).format('DD-MM-YYYY');
        const fileType = format.toLowerCase();

        return {
          url: `/private/river/${accountId}/transaction/${fileType}?start=${startDate}&end=${endDate}&language=${language}`,
          method: 'GET',
          responseHandler: (response: Response) => response.blob(),
        };
      },
    }),
  }),
});

export const { useLazyGetAccountStatementQuery } = accountApi;

export const downloadAccountStatement = (
  trigger: ReturnType<typeof useLazyGetAccountStatementQuery>[0],
  params: {
    accountId: number;
    dateRange: [string, string];
    format?: FileFormat;
    language?: string;
  }
) =>
  downloadFile(trigger, params, (p) => {
    const format = p.format ?? FileFormat.PDF;
    return `statement.${format.toLowerCase()}`;
  });
